import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

// material-ui
import MaterialTable from 'material-table';
import Typography from '@material-ui/core/Typography';

// component
import tableIcons from '../../../components/table/MaterialTableIcon';

export default function WaveDetailList(props) {
  const { t } = useTranslation();
  const { datas } = props;

  console.log('+++++++',datas);

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        data={datas.red}
        columns={[
          {
            title: t('ชื่อสถานี'),
            field: 'name',
            width: 230,
            headerStyle: {
              left: 0,
              position: 'sticky',
              zIndex: 50,
              backgroundColor: '#CCCCCC',
            },
            cellStyle: {
              backgroundColor: '#fff',
              left: 0,
              position: 'sticky',
              wordWrap: 'normal',
              textAlign: 'left',
            },
          },
          {
            title: t('ที่ตั้ง'),
            field: 'province_name.th',
            type: 'string',
            export: false,
            width: 350,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
          },
          // {
          //   title: 'เวลา',
          //   title_export: 'เวลา',
          //   field: 'datetime',
          //   type: 'date',
          //   width: 115,
          //   render: (rowData) => `${moment(rowData.datetime).locale('th').format('LT')} น.`,
          // },
          {
            title:
  <>
    {t('ความสูงของคลื่น')}
    <br />
    <Typography variant="caption" display="block">
      (
      {t('เมตร')}
      )
    </Typography>
  </>,
            field: 'wave_height',
            type: 'numeric',
            width: 80,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${row.wave_height}`,
          },
        ]}
        localization={{
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: false,
          showTitle: false,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

WaveDetailList.propTypes = {
  datas: PropTypes.instanceOf(Object).isRequired,
};
